import useTranslation from "../client/hooks/useTranslation";
import { Button } from "../client/components/ui/button";

interface CompareBarProps {
  count: number;
  onOpen: () => void;
  onReset: () => void;
}

export default function ComparatorCompareBar({
  count,
  onOpen,
  onReset,
}: CompareBarProps) {
  const t = useTranslation();

  if (count < 2) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-3 rounded-full border border-border bg-card px-5 py-3 shadow-lg">
      <span className="font-medium text-foreground">
        {t.comparator.compareBar.replace("{n}", String(count))}
      </span>
      <Button onClick={onOpen}>{t.comparator.compareTitle}</Button>
      <Button variant="ghost" onClick={onReset}>
        {t.comparator.compareReset}
      </Button>
    </div>
  );
}
